import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import MsgUtils from '../Tools/MsgUtils';
import UtilsBufer from '../Tools/UtilsBufer';
import DateConverter from '../Tools/DateConverter';
import CircleLoader from "react-spinners/CircleLoader";
import felizCumpleImg from '../../assets/felizCumple.gif';
import ModalCargando from '../utilsComponentes/ModalCargando';
const server = process.env.REACT_APP_SERVER;

function CumpleNoticias(props) {
  const { setEnable } = props;
  const [listaCumples, setListaCumples] = useState([]);
  const [modalCumple, setModalCumple] = useState(false);
  const [selectCumple, setSelectCumple] = useState({});
  const [loading, setLoading] = useState(true);
  const [selectMensajes, setSelectMensajes] = useState([]);
  const [textMensaje, setTextMensaje] = useState('');
  const [regional,setRegional] = useState('');
  const [actualizar,setActualizar] = useState(0);
  function tituloCumple(dia) {
    var fecha = new Date().getDate();
    console.log(fecha, dia);
    if (parseInt(dia) === fecha) {
      return "Hoy es su Cumpleaños "
    } else {
      var dif = Math.abs(dia - fecha);
      return `a ${dif} dias de su cumpleaños..`
    }
  }
  const enviarMensaje = async () => {
    var empleado = JSON.parse(localStorage.getItem('info'))
    fetch(`${server}/redSocial/enviarMensaje`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        regional: regional,
        idEmpleado: selectCumple.ID_EMPLEADO,
        idEmpleadoF: empleado.ID_EMPLEADO,
        mensaje: textMensaje
      })
    })
      .then(res => res.json())
      .then(data => {
        console.log(data);
        setActualizar(actualizar+1);
        if (data.ok) {
          setTextMensaje('');
          setModalCumple(false);
        } else {
          MsgUtils.msgError(data.error);
        }
      })
      .catch(err => console.log(err));
  }
  const mostrarDialogo = async (item) => {
    fetch(`${server}/redSocial/getCumpleMensajes`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        regional: regional,
        idEmpleado: item.ID_EMPLEADO
      })
    })
      .then(res => res.json())
      .then(data => {
        console.log(data)
        if (data.ok) {
          setSelectMensajes(data.ok)
          setSelectCumple(item);
          setModalCumple(true);
          console.log(item);
        } else {
          MsgUtils.msgError(data.error);
        }
      })
      .catch(err => console.log(err));
  }
  async function actualizarCumpleaneros(ciudad){
    fetch(`${server}/redSocial/getCumple`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        regional: ciudad,
        fecha: DateConverter.formatoFechaHoy()
      })
    })
      .then(res => res.json())
      .then(data => {
        setEnable(false);
        console.log(data)
        if (data.ok) {
          setListaCumples(data.ok);
          setLoading(false);
        } else {
          MsgUtils.msgError(data.error);
        }
      })
      .catch(err => console.log(err));
  }
  useEffect(() => {
    var info = JSON.parse(localStorage.getItem('__react_session__'));
    if(regional==''){
      setRegional(info.regional);
    }
    if (listaCumples.length === 0) {
      actualizarCumpleaneros(info.regional);
    }
  }, []);
  useEffect(()=>{
    if (listaCumples.length>0){
      setLoading(true);
      actualizarCumpleaneros(regional);
    }
  },[actualizar])
  return (
    <div className='container-fluid overflow-auto configOverFlow py-1'>
      <ModalCargando show={loading}/>
      {listaCumples.map((item) => {
        return (
          <div className="card col-sm-10 col-md-8 col-lg-4 mx-auto mb-3 bg-dark bg-gradient" key={item.ID_EMPLEADO}>
            <div className="card-header m-0 p-1">
              <div className='row row-col-2 g-1'>
                <div className='col-8 m-0 p-0 my-auto'>
                  <div className="card bg-transparent flex-row m-0 p-0" style={{ border: 'none' }}>
                    <div className={parseInt(item.DIA) === new Date().getDate() ? 'fa-beat fa-bounce' : ''}>{UtilsBufer.getFotoCard(item.FOTO, parseInt(item.DIA) === new Date().getDate() ? 80 : 40)}</div>
                    <div className='ps-2 my-auto text-light'>
                      <div className="noticiasHeader fw-bold">{item.NOMBREX}</div>
                    </div>
                  </div>
                </div>
                {parseInt(item.DIA) === new Date().getDate() ?
                  <div className='col-4 m-0 p-0 my-auto text-success text-center'>
                    <i className="fa-solid fa-cake-candles fa-xl fa-beat"></i><span className='text-light'> {DateConverter.formatoFechaCorto(item.CARNET_NACIMIENTO)}</span>
                  </div>
                  :
                  <div className='col-4 m-0 p-0 my-auto text-light text-center'>
                    <i className="fa-solid fa-cake-candles fa-xl"></i> {DateConverter.formatoFechaCorto(item.CARNET_NACIMIENTO)}
                  </div>
                }
              </div>
            </div>
            <div className="card-body m-0 p-1">
              <div className="card-title text-light fw-6 fw-bold">{tituloCumple(item.DIA)}</div>
              {parseInt(item.DIA) === new Date().getDate() && <div className='text-center'><img src={felizCumpleImg} className="img-fluid"></img></div>}
              {parseInt(item.DIA) === new Date().getDate() &&
                <div className="input-group mb-3">
                  <span className="input-group-text bg-dark text-light border border-dark ">Envia tu Felicitación :</span>
                  <button className='btn btn-sm btn-success bg-gradient mx-1 ' onClick={() => mostrarDialogo(item)}>
                    <i className="fa-solid fa-gifts fa-beat"></i> Felicitar</button>
                  <span className='input-group-text bg-dark text-light fw-bold m-0 p-0 border border-dark'>{`${item.FELICITACIONES} Comentarios`}</span>
                </div>}
            </div>
          </div>
        )
      })}
      <Modal show={modalCumple} onHide={() => setModalCumple(false)}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        contentClassName='bg-dark bg-gradient'>
        <Modal.Header closeButton closeVariant='white' bsPrefix='modal-header m-0 p-0 px-2'>
          <Modal.Title>
            <div className="card bg-transparent flex-row m-0 p-0" style={{ border: 'none' }}>
              {UtilsBufer.getFotoCard(selectCumple.FOTO, 40)}
              <div className='ps-2 my-auto text-light'>
                <div className="noticiasHeader fw-bold">{selectCumple.NOMBREX}</div>
                <div className='noticiasHeader '>{selectCumple.CARGO}</div>
              </div>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='container-fluid'>
            {selectMensajes.map((item) => {
              return (
                <div className='py-1' key={item.ID_EMPLEADO_FELICITA}>
                  <div className="card bg-transparent flex-row m-0 p-0 border border-light">
                    {UtilsBufer.getFotoCard(item.FOTO, 30)}
                    <div className='ps-2 my-auto text-light'>
                      <div className="noticiasHeader fs-6">{UtilsBufer.getText(item.MENSAJE)}</div>
                    </div>
                  </div>
                </div>
              )
            })}
            <div className='container-fluid py-2'>
              <div className="input-group mb-3">
                <input type="text" className="form-control" placeholder="Escriba Mensaje"
                  value={textMensaje} onChange={(e) => setTextMensaje(e.target.value)} />
                <button className='btn btn-secondary' onClick={() => enviarMensaje()}>
                  <i className="fa-solid fa-paper-plane"></i> Enviar
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  )
}

export default CumpleNoticias

